import ConfirmModalUI from '@/components/common/ConfirmModalUI/ConfirmModalUI'
import { debounce } from 'lodash'
import { useConfigUI } from '../../context'
import { useDeleteEtZone } from '../../hooks/etZone'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
  onSuccess?: () => void
}

const DeleteEtzModal = ({
  id,
  interfaceId,
  onSuccess,
}: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()

  const deleteModal = useDeleteEtZone()

  const handleDeleteEmitter = debounce(async () => {
    if (!id) return
    if (!interfaceId) return
    deleteModal(
      { interfaceId, id },
      {
        onSuccess: () => {
          onSuccess && onSuccess()
        },
      },
    )
  }, 300)

  return (
    <ConfirmModalUI
      title={t('DeleteEtz')}
      text={t('etzDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteEmitter}
    />
  )
}

export default DeleteEtzModal